/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import VirtualAgentAiAnswersSrcQuery, {
	type VirtualAgentAiAnswersSrcQuery as QueryType,
} from './__generated__/VirtualAgentAiAnswersSrcQuery.graphql';

type AiAnswersEntryPointComponent = EntryPointComponent<
	{
		page: QueryType;
	},
	{},
	{},
	{} | null
>;

export const aiAnswersEntryPoint: EntryPoint<AiAnswersEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<AiAnswersEntryPointComponent>(
			/* webpackChunkName: "async-virtual-agent-ai-answers" */ './VirtualAgentAiAnswers.tsx',
		),
		getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
			queries: {
				page: {
					parameters: VirtualAgentAiAnswersSrcQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey ?? '',
					},
				},
			},
		}),
	});
